export enum MainPlan {
  /** 语音识别 (秒) */
  ai_asr = 'ai_asr',
  /** 智能分镜 (秒) */
  ai_dvs = 'ai_dvs',
  /** 语音合成 (次) */
  ai_tts = 'ai_tts',
  /** 视频ocr */
  video_ocr = 'video_ocr',
  /** 下载数 */
  downloads = 'downloads_and_push',
  /** 套餐视频导出数 */
  videos = 'videos',
  /** 点数 **/
  video_credits = 'video_credits',
  /** 语音克隆（次） */
  voice_clone = 'voice_clone',
  /** 创建工单 */
  order = 'order',
  /** ai banner */
  ai_banner = 'ai_banner',
}

export enum ExtraPlan {
  extra_ai_asr = 'extra_ai_asr',
  extra_ai_dvs = 'extra_ai_dvs',
  extra_ai_tts = 'extra_ai_tts',
  extra_downloads = 'extra_downloads_and_push',
  extra_videos = 'extra_videos',
  extra_video_credits = 'extra_video_credits',
  extra_voice_clone = 'extra_voice_clone',
}
